import * as ActionTypes from './../constants';
import { baseUrl } from './../index';
// import { AsyncStorage } from 'react-native';
import axios from 'axios';
import { getUserToken } from './../getUserToken';


export default function(state={}, action) {
    switch(action.type) {
        case ActionTypes.REQUEST_GET_HTML_CONTENT : 
            return {
                ...state,
                loading: true,
                error:false,
                errInfo: null, 
                response: null
            }
        case ActionTypes.RECEIVED_GET_HTML_CONTENT : 
            return {
                ...state,
                loading: false,
                response: action.res,
                error: false,
                errInfo: null
            }
        case ActionTypes.ERROR_GET_HTML_CONTENT: 
            return {
                ...state,
                loading: false,
                error: true,
                errInfo: action.err,
                response: null
            }
        case ActionTypes.CLEAR_GET_HTML_CONTENT: 
            return { }
        default :  return state
    }

}


const dispatchRequestGetHtmlContent = () => ({
    type: ActionTypes.REQUEST_GET_HTML_CONTENT,
})
const dispatchReceivedGetHtmlContent = res => ({
    type: ActionTypes.RECEIVED_GET_HTML_CONTENT,
    res
})
export const dispatchClearGetHtmlContent = () => ({
    type: ActionTypes.CLEAR_GET_HTML_CONTENT    
})
const dispatchErrorGetHtmlContent = err => ({
    type: ActionTypes.ERROR_GET_HTML_CONTENT,
    err
})



export const getGetHtmlContent = ({subjectId, examId, topicId, contentId}, isLibrary) => dispatch => {

    const endPoint = isLibrary ? 'epub': 'material';
    const data = isLibrary 
                ? {
                    subject_id: subjectId,
                    exam_id: examId,
                    topic_id:topicId,
                    id:contentId
                } : 
                {
                    course_id: subjectId,
                    exam_id: examId,
                    lesson_planner_id:topicId,
                    id:contentId
                };

    dispatch(dispatchRequestGetHtmlContent(data));

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'post',
                url: `${baseUrl}/api/${endPoint}`,                            
                data,           
                headers: {
                    'Authorization': `Bearer ${authKey}`
                }
            }          
            return axios(options)
                .then(({data}) => {                  
                    dispatch(dispatchReceivedGetHtmlContent(data))
                })
        })
        .catch(e => dispatch(dispatchErrorGetHtmlContent(e)));    
}